export const stepzoneRed = "#ff0000";
export const stepzoneYellow = "#E0CA00";
export const stepzoneGreen = "#008000";
export const stepzoneGray = "#858585";
export const stepzoneBlue = "#001AFF";
